import { cleanContent, moveWidgetsToMainContent } from '@helpers/helpers.js';
import swiperWidget from '@commonWidgets/slider.js';
import countdown from '@commonWidgets/countdown.js';
import masonryCards from '@commonWidgets/masonryCards.js';
import seoWidget from '@commonWidgets/seo.js';
import signup from '@commonWidgets/signupText.js';
import sponsorWidget from '@commonWidgets/sponsors.js';
import gridGallery from '@commonWidgets/gallery.js';

export default function (themes) {
  const { classHome: stateFairHome, idContainer: widgetContainer } = themes[3];
  const isStateFairHome = $('body').hasClass(stateFairHome);

  if (isStateFairHome) {
    $(document).ready(function () {
      cleanContent(stateFairHome);
      moveWidgetsToMainContent(widgetContainer);
      swiperWidget('oktSwiperWidget', oktSwiperWidgetOpts);
      countdown('oktDatesWidget', oktDatesWidgetOpts);
      masonryCards('oktTwoCardsWidget', oktTwoCardsWidgetOpts, 2);
      masonryCards('oktFourCardsWidget', oktFourCardsWidgetOpts, 4);
      seoWidget('oktSeoWidget', oktSeoWidgetOpts);
      signup('oktSignup', oktSignupOpts, true);
      sponsorWidget();
      gridGallery('oktGridGallery', oktGridGalleryOpts);
    });
  }
}
